import React, { useContext } from 'react';
import { StoreContext } from '../../store';
import './index.css';

import Slider from 'react-slick';

import LinkedInWhite from '../../assets/landing-page/linkedin-white.svg';
import GmailWhite from '../../assets/landing-page/gmail-white.svg';

import {
  FaEnvelope,
  FaLinkedinIn
} from "react-icons/fa";

import LinkedIn from '../../assets/landing-page/linkedin.svg';
import Gmail from '../../assets/landing-page/gmail.svg';

import { teamData, advisorsData } from '../../constants';
import Bernardita from '../../assets/landing-page/team/Bernardita C.jpg';
import Deepti from '../../assets/landing-page/team/Deepti M.png';

const About = () => {
  const { state } = useContext(StoreContext);
  const { isMobile } = state;
  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: isMobile ? 1 : 4,
    slidesToScroll: isMobile ? 1 : 4,
    swipeToSlide: false,
    arrows: true,
  };

  return (
    <div className='About'>
      <section className='who-we-are'>
        {/* <LazyImage src={BG1} placeholder={BG1PH} alt='' /> */}
        <div className="bg-[#1c293a] text-white text-3xl text-center py-12">
          <div className="px-4">ABOUT WALKSPAN</div>
        </div>
        <div className="bg-white min-h-[calc(70svh-132px)] py-12 px-8 bg-abstract">
          <div className='text-[20px] text-center text-black leading-[1.58] max-w-[400px] md:max-w-[800px] mx-auto px-4 mb-12'>
            Founded in 2019, Walkspan is revolutionizing real estate by emphasizing the importance of place and 
            walkable urban living. Created by a team of experts in location intelligence, real estate, 
            sustainability, and urban planning with over 30 years of combined experience on award-winning 
            projects, Walkspan stands as the only neighborhood search platform of its kind.
          </div>
          <div className="max-w-screen-xl mx-auto text-lg grid grid-cols-1 md:grid-cols-3 gap-6 px-4">
            <div className="bg-[#1c293a] text-white p-6 shadow-md flex">
              <div className='text-center'>
                Walkspan is a sustainable company with a unique value system and 
                mission to shape the public realm of tomorrow. We are passionate about 
                celebrating <b>neighborhood character and quality</b>.
              </div>
            </div>
            <div className="bg-[#1c293a] text-white p-6 shadow-md flex">
              <div className='text-center'>
                We are a data and  <b>technology company</b> dedicated to accelerating 
                public realm transformation through <b>AI-driven metrics</b>.
              </div>
            </div>
            <div className="bg-[#1c293a] text-white p-6 shadow-md flex">
              <div className='text-center'>
                We are impact entrepreneurs, an interdisciplinary team in the technology, 
                <b> location intelligence</b>, data, and environmental fields.
              </div>
            </div>
          </div>
        </div>
        {/* <section className='what-we-do max-w-screen-lg'>
          <h1 className='landing-title'>What We Do</h1>
          <p>
            Walkspan reveals neighborhood character and quality through its
            neighborhood intelligence platform. A platform that seamlessly
            integrates with real estate search engines to help buyers and
            renters find homes in walkable neighborhoods. Buying homes where
            lifestyle essentials are within walking distance improves quality of
            life and brings sustainable impacts.
          </p>
        </section> */}
      </section>
      <div className="founders-section bg-white pb-12">
        <div className="text-white text-center bg-[#1c293a] text-2xl font-medium mx-auto p-8">
          We have 35 years of combined experience in data management, location intelligence, urban studies, and operations.
        </div>
        <div className="max-w-screen-xl mx-auto py-12 px-8 mb-4 ">
          <div className='flex flex-col lg:flex-row gap-16 mt-16'>
            <div className="flex flex-col items-center mx-auto max-w-[350px]">
              <img
                src={Bernardita} 
                alt="Bernardita Calinao, PhD"
                className="w-48 h-48"
              />
              <div className="text-center mt-6 md:mt-2">
                <h2 className="text-xl font-medium">Bernardita Calinao, PhD</h2>
                <p className="mt-2">Founder and CEO</p>
                <div className='flex gap-2 items-center justify-center advisor-links pl-0'>
                  <a
                    href="https://www.linkedin.com/in/bernarditacaliano"
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <FaLinkedinIn className='"w-5 h-5' color='#758ca3' />
                  </a>
                  <a href="mailto:bernardita@example.com">
                    <FaEnvelope className='"w-5 h-5' color='#758ca3' />
                  </a>
                </div>
              </div>
            </div>

            <div className="text-base leading-7 text-left w-full md:w-[70%]">
              <p>
                <span className="font-bold">Bernardita</span> is passionate about urban livability, walkability, and sustainability. As a Human Ecologist and Environmental Planner, she has directed over 35 environmental and sustainable development studies for multimillion infrastructure investment projects in the US and abroad. Bernardita has been involved in multi-sector stakeholder negotiations representing international, private, government sectors and indigenous communities. Several of her projects won awards for excellence in engineering through the application of geographic information systems to map environmental impacts and place-based environmental solutions. 
              </p>
              <p className="mt-6">
                Six years ago, Bernardita launched Walkspan. Her interest in walkability and urban livability is deeply rooted in her years of environmental work in the transportation and urban sectors. She now dedicates her career towards unfolding the power of place by leveraging the largest repository of data on the walking environment. Bernardita holds PhD and Master’s degrees in Environmental Science from the State University of New York College of Environmental Science and Forestry, Syracuse, New York.
              </p>
            </div>
          </div>
          <p className="mt-10 text-lg">
            "Walkspan is fortunate to be fully supported by and amazing team of software developers, data scientists, location and urban planning experts in the US and abroad."
          </p>
          {/* <div className='flex flex-col lg:flex-row gap-4 mt-16'>
            <div className="flex flex-col mx-auto max-w-[235px]">
              <div className="">
                <img
                  src={Deepti} 
                  alt="Deepti Mittal, MBA"
                  className="w-48 h-48"
                />
              </div>
              <div className="text-center mt-6 md:mt-2">
                <h2 className="font-bold text-gray-900">Deepti Mittal, MBA</h2>
                <p className="text-gray-600 font-medium">Co-founder and CMO</p>
                <div className='flex gap-2 items-center 2xs:justify-center advisor-links pl-0'>
                  <a
                    href="https://www.linkedin.com/in/bernarditacaliano"
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <FaLinkedinIn className='"w-5 h-5' color='#758ca3' />
                  </a>
                  <a href="mailto:bernardita@example.com">
                    <FaEnvelope className='"w-5 h-5' color='#758ca3' />
                  </a>
                </div>
              </div>
            </div>

            <div className="text-gray-700 text-base leading-7 text-left lg:w-4/5">
              <p>
                Deepti is passionate about real estate, community, and helping clients navigate New York City’s dynamic market with confidence. As the founder of the Mittal/Talwar Team at Douglas Elliman, she brought over 30 years of deep local expertise and led her team to rank among the firm’s top-performing agents.
              </p>
              <p className="mt-6">
                Her diverse clientele—including international investors, relocating families, and high-profile individuals—benefited from her strategic approach, market insight, and commitment to personalized service. Backed by an MBA in Marketing and International Trade, Deepti combined strong business acumen with a thoughtful, results-driven mindset.
              </p>
              <p className="mt-6 italic">
                In addition to residential sales and investments, Deepti offered tailored property management services, supporting clients in maintaining and growing the value of their real estate assets. Her work was grounded in professionalism, integrity, and a belief that every client deserved dedicated attention and a data-informed strategy. Whether securing a dream home or managing a portfolio, Deepti brought clarity, care, and confidence to every transaction—building lasting relationships and delivering consistent results.
              </p>
            </div>
          </div> */}
        </div>
      </div>
      <section className='bg-[#1c293a] text-white py-12 px-8'>
        <h1 className='landing-title'>Meet Our Advisors</h1>
        <p className='quote max-w-[600px] mx-auto text-lg '>
          We have a <b>network of professionals</b> in real estate technology
          and marketing to create synergies and share ideas on walkability.
        </p>
        <div className='flex flex-wrap justify-around mt-8 mx-auto relative max-w-screen-xl'>
          {advisorsData.map((advisor, index) => (
            <div key={index} className='advisor-item max-w-fit w-full flex !items-center !justify-center !text-center'>
              <img src={advisor.img} alt={advisor.name} />
              <h3>{advisor.name}</h3>
              <p>{advisor.title}</p>
              <div className='flex gap-2 advisor-links pl-4'>
                <a
                  href={advisor.linkedIn}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaLinkedinIn className='w-5 h-5 mt-2' color='#758ca3' />
                </a>
                {/* <a href={advisor.email}>
                  <img src={GmailWhite} alt='Email' />
                </a> */}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
